var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.thisStep,{tag:"component"},[(_vm.isWrapper)?_c('TagWrapper',{attrs:{"steps":_vm.steps}},[_vm._t("default")],2):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }